import { getSdk } from "../services/sdkService";
export async function isForceLogout(error) {
  //const userLogged = getAppState().userLogged;
  const sdk = await getSdk();
  const loggedIn = await sdk.authenticationManager.isLoggedIn();
  const errorStatus =
    error && error.status ? error.status : error.response && error.response.status ? error.response.status : null;
  const errorCode =
    error && error.error_code
      ? error.error_code
      : error.response && error.response.data && error.response.data.error_code
      ? error.response.data.error_code
      : null;
  console.log("errorStatus", errorStatus);
  console.log("errorCode", errorCode);
  if (loggedIn && (errorStatus === 403 || errorStatus === 401 || errorStatus === 407)) {
    console.log("isForceLogout === true");
    return true;
  }
  return false;
}
